"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[995],{

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ CardInnerTitle; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_common_Help__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33869);





var CardInnerTitle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("padding:1.5rem 1rem;border-bottom:2px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.border */ .O9.border, ";display:flex;align-items:center;height:64px;", props.isSpaceBetween && "justify-content: space-between;"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("h3", {
                "data-test-id": props["data-test-id"],
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0 4px 0 0;font-size:16px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";"),
                children: props.title
            }),
            props.helpText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_common_Help__WEBPACK_IMPORTED_MODULE_2__/* .Help */ .W, {
                linkTo: props.helpLink || undefined,
                size: "large",
                children: props.helpText
            }),
            props.sub && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:14px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";margin:0 35px 0 16px;", props.subTitleCss),
                children: props.sub
            }),
            props.children
        ]
    });
};


/***/ }),

/***/ 14380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ FormattedDate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57923);
/* harmony import */ var _lib_wovn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15598);




// Returns formatted date of iso string
var FormattedDate = function(props) {
    if (!props.children) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
            className: _lib_wovn__WEBPACK_IMPORTED_MODULE_2__/* .IGNORED_BY_WOVN_CLASS_NAME */ .Y,
            suppressHydrationWarning: true,
            children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(props.children, "yyyy/MM/dd")
        })
    });
};


/***/ }),

/***/ 89277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ LineClampText; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var LineClampText = function(param) {
    var lineNumber = param.lineNumber, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll, _height = param.height, height = _height === void 0 ? 1.4 : _height, _size = param.size, size = _size === void 0 ? "14px" : _size, _stripLineBreaks = param.stripLineBreaks, stripLineBreaks = _stripLineBreaks === void 0 ? false : _stripLineBreaks, _justify = param.justify, justify = _justify === void 0 ? false : _justify, lineClampRef = param.lineClampRef, className = param.className, children = param.children, dataTestId = param.dataTestId;
    if (typeof lineNumber === "number") {
        lineNumber = {
            desktop: lineNumber,
            mobile: lineNumber
        };
    }
    var text = stripLineBreaks ? children === null || children === void 0 ? void 0 : children.replace(/(\r\n|\n|\r)/gm, "") : children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
        title: text !== null && text !== void 0 ? text : "",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("line-height:", height, ";font-size:", size, ";", justify ? "text-align: justify;" : "", " ", showAll || "\n          max-height: calc(".concat(size, " * ").concat(height, " * ").concat(lineNumber.desktop, ");\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          -webkit-line-clamp: ").concat(lineNumber.desktop, ";\n          ").concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, " {\n            max-height: calc(").concat(size, " * ").concat(height, " * ").concat(lineNumber.mobile, ");\n            -webkit-line-clamp: ").concat(lineNumber.mobile, ";\n          }\n        ")),
        className: className,
        ref: lineClampRef,
        "data-test-id": dataTestId,
        children: text
    });
};


/***/ }),

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ol": function() { return /* binding */ ModalCloseButton; },
/* harmony export */   "r6": function() { return /* binding */ ModalTitle; },
/* harmony export */   "u_": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);
/* harmony import */ var _contexts_ModalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84423);






var Modal = function(props) {
    var onChangeModalVisibility = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_ModalContext__WEBPACK_IMPORTED_MODULE_3__/* .ModalContext */ .t);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        onChangeModalVisibility(!props.isHidden);
    }, [
        props.isHidden,
        onChangeModalVisibility
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ModalOverlay, {
        zIndex: props.zIndex,
        isHidden: props.isHidden,
        onClose: props.onClose,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ModalCard, {
            className: props.className,
            children: props.children
        })
    });
};
var ModalOverlay = function(props) {
    if (props.isHidden) {
        return null;
    }
    var _zIndex;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("bottom:0;left:0;right:0;top:0;position:fixed;z-index:", (_zIndex = props.zIndex) !== null && _zIndex !== void 0 ? _zIndex : 100, ";width:100%;height:100%;background-color:rgba(0,0,0,0.3);"),
        onClick: props.onClose,
        children: props.children
    });
};
var ModalCard = function(props) {
    var handleClickCard = function(e) {
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("box-sizing:border-box;position:relative;padding-left:5px;padding-right:5px;position:fixed;height:auto;top:50%;left:50%;transform:translate(-50%,-50%);width:fit-content;max-width:fit-content;"),
        className: props.className,
        onClick: handleClickCard,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
            className: "modal-content",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("border-radius:5px;padding:24px 32px;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.white00 */ .O9.white00, ";min-height:150px;"),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                children: props.children
            })
        })
    });
};
var ModalTitle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        "data-test-id": props["data-test-id"],
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("line-height:24px;margin:0;font-size:16px;text-align:left;color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textStrong */ .O9.textStrong, ";font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .font.weight.bold */ .LZ.weight.bold, ";"),
        children: props.children
    });
};
var FOCUS_STYLE = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("&:focus-visible{outline:2px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black10 */ .O9.black10, ";outline-offset:0.15rem;transition:initial;border:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.gray80 */ .O9.gray80, ";}");
var ModalCloseButton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("button", {
        "data-test-id": props["data-test-id"],
        onClick: props.onClick,
        className: "close",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("background-color:transparent;border:none;border-radius:50%;cursor:pointer;padding:0;appearance:none;width:32px;height:32px;/* ボタン位置の微調整 */\n        position:relative;right:-10px;&:hover{background-color:#d9d9d9;}i.modal-close{font-size:85%;line-height:32px;}", FOCUS_STYLE),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: "close1",
            className: "modal-close"
        })
    });
};


/***/ }),

/***/ 15071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ TagButton; },
/* harmony export */   "U": function() { return /* binding */ TagButtonGroup; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48261);






var TagButton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("li", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:inline-block;margin:0 4px 4px 0;"),
        "data-test-id": "tag",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: _lib_url__WEBPACK_IMPORTED_MODULE_3__/* .TAG_HREF */ .cS,
            as: "slug" in props.tag ? (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .newTagPath */ .w6)(props.tag) : props.tag.path,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
                "data-test-id": "tag-link",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";border-radius:3px;padding:2px 6px;font-size:12px;line-height:1.5;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray90 */ .O9.gray90, ";text-align:center;display:block;white-space:nowrap;transition:0.3s;&:hover{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray70 */ .O9.gray70, ";}"),
                className: "tag-button ".concat(props.className ? props.className : ""),
                children: "#".concat(props.tag.name)
            })
        })
    });
};
var TagButtonGroup = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ul", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin:0 0 -4px;padding:0;"),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: props.children
    });
};


/***/ }),

/***/ 23581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ EmptyCard; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);




var EmptyCard = function(props) {
    var _children;
    var text = (_children = props.children) !== null && _children !== void 0 ? _children : "表示するデータがありません";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Zb, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card.Content */ .Zb.Content, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
                className: "empty",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("display:flex;align-items:center;justify-content:center;color:#999;font-size:14px;padding:5px;"),
                "data-test-id": props.dataTestId,
                children: text
            })
        })
    });
};


/***/ }),

/***/ 98139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ FullwidthArticleCard; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _lib_markdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11566);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48261);
/* harmony import */ var _atoms_LineClampText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89277);
/* harmony import */ var _atoms_TagButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15071);
/* harmony import */ var _pages_articles_LockIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92339);
/* harmony import */ var _atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14380);











var FullwidthArticleCard = function(props) {
    var ref;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Zb, {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray50 */ .O9.gray50, ";"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card.Content */ .Zb.Content, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("display:grid;grid-template-columns:1fr 120px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{grid-template-columns:160px 1fr;}"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("grid-row:1 / 2;grid-column:2 / 3;margin-left:8px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{grid-row:1 / 3;grid-column:1 / 2;margin:0 16px 0 0;}"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: _lib_url__WEBPACK_IMPORTED_MODULE_3__/* .ARTICLE_HREF */ .ph,
                            as: (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .articlePath */ .wL)(props.article),
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("display:block;position:relative;border-radius:2px;&::before{content:'';display:block;width:100%;height:100%;background-color:transparent;border-radius:2px;position:absolute;transition:background-color 0.2s ease;}&:hover::before{background-color:rgba(0,0,0,0.08);}"),
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("img", {
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("display:block;border-radius:2px;width:100%;object-fit:contain;aspect-ratio:1.91 / 1;"),
                                    src: props.article.headerImage.url
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("grid-row:1 / 2;grid-column:1 / 2;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{grid-row:1 / 2;grid-column:2 / 3;}"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_pages_articles_LockIcon__WEBPACK_IMPORTED_MODULE_6__/* .LockIcon */ .m, {
                                article: props.article
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: _lib_url__WEBPACK_IMPORTED_MODULE_3__/* .ARTICLE_HREF */ .ph,
                                as: (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .articlePath */ .wL)(props.article),
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
                                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black10 */ .O9.black10, ";font-size:15px;line-height:1.5;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.bold */ .LZ.weight.bold, ";letter-spacing:0.02em;text-decoration:underline solid transparent;transition:text-decoration 0.2s ease 0s;&:hover{text-decoration:underline solid Currentcolor;}", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{font-size:14px;}"),
                                        children: props.article.title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("p", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin:4px 0 0;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textLight */ .O9.textLight, ";font-size:12px;letter-spacing:0.02em;line-height:1.25;"),
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_7__/* .FormattedDate */ .J, {
                                    children: props.article.publishedAt
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("p", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("display:none;margin:4px 0 0;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{display:block;}"),
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_LineClampText__WEBPACK_IMPORTED_MODULE_4__/* .LineClampText */ .R, {
                                    lineNumber: 2,
                                    size: "12px",
                                    height: 1.5,
                                    children: (0,_lib_markdown__WEBPACK_IMPORTED_MODULE_10__/* .stripMarkdown */ .LV)(props.article.introduction)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:4px;grid-row:2 / 3;grid-column:1 / 3;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{grid-row:2 / 3;grid-column:2 / 3;}"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_TagButton__WEBPACK_IMPORTED_MODULE_5__/* .TagButtonGroup */ .U, {
                            children: (ref = props.article.newTags) === null || ref === void 0 ? void 0 : ref.map(function(tag, i) {
                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_TagButton__WEBPACK_IMPORTED_MODULE_5__/* .TagButton */ .D, {
                                    tag: tag
                                }, i);
                            })
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 53565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zv": function() { return /* binding */ InViewForActiveTab; },
/* harmony export */   "ji": function() { return /* binding */ setupActiveTabs; },
/* harmony export */   "ze": function() { return /* binding */ createInViewEventQueue; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42708);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);







var STICKY_HEADER_OFFSET = "-220px 0px 0px 0px";
var InViewForActiveTab = function(props) {
    var mobileOffset = props.mobileOffset || props.offset;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)({
        threshold: [
            0,
            1
        ],
        rootMargin: props.stickyOffset || STICKY_HEADER_OFFSET
    }), 2), ref1 = ref[0], inView = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        props.onChangeActive(props.tabName, inView);
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(AnchorWithOffset, {
                id: props.tabName,
                offset: props.offset,
                mobileOffset: mobileOffset
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                ref: ref1,
                id: props.tabName + "-contents",
                className: props.className,
                children: props.children
            })
        ]
    });
};
var AnchorWithOffset = function(param) {
    var id = param.id, offset = param.offset, mobileOffset = param.mobileOffset;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        id: "".concat(id),
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:block;position:relative;top:", offset, ";visibility:hidden;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{top:", mobileOffset, ";}")
    });
};
var createInViewEventQueue = function() {
    var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50;
    var queue = [];
    var handle = null;
    var push = function(tab, inView, timeoutFn) {
        queue.push([
            tab,
            inView
        ]);
        if (handle) {
            clearTimeout(handle);
        }
        handle = setTimeout(timeoutFn, duration);
    };
    var apply = function(activeTabs) {
        var newTabs = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, activeTabs);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = queue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_step.value, 2), tab = _value[0], state = _value[1];
                newTabs[tab] = state;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        queue = [] // clear
        ;
        return newTabs;
    };
    return [
        push,
        apply
    ];
};
var setupActiveTabs = function(list) {
    var init = function() {
        return Object.fromEntries(list.map(function(tab) {
            return [
                tab,
                false
            ];
        }));
    };
    var first = function(activeTabs) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tab = _step.value;
                if (activeTabs[tab]) {
                    return tab;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    return [
        init,
        first
    ];
};


/***/ }),

/***/ 6178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ViewMoreLink; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20932);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);






var ViewMoreLink = function(props) {
    // NOTE: props.onClickを渡すと、Hrefでの遷移はなくなる
    if (props.isHidden) {
        return null;
    }
    var _prefetch = props.prefetch, prefetch = _prefetch === void 0 ? true : _prefetch;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;align-items:center;justify-content:center;width:100%;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white10 */ .O9.white10, ";padding-block:21px;font-size:14px;line-height:1;"),
        "data-test-id": props.dataTestId,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: props.href,
            as: props.as,
            prefetch: prefetch,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_atoms_A__WEBPACK_IMPORTED_MODULE_1__.A, {
                decoration: "none",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;align-items:center;"),
                onClick: props.onClick,
                "data-testid": "view-more-link",
                target: "_blank",
                children: [
                    "もっと見る",
                    props.count && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("span", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(),
                        children: [
                            "\xa0（",
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
                                "data-testid": "view-more-count",
                                children: props.count
                            }),
                            "）"
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 92339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ LockIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var _atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96747);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18584);
/* harmony import */ var _lib_article__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9427);
/* harmony import */ var _tokens_mediaquery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67014);







var small = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("@media (min-width:", _tokens_mediaquery__WEBPACK_IMPORTED_MODULE_5__/* .desktopMinWidth */ .n, "){font-size:24px;}");
var common = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin-right:3px;");
var LockIcon = function(props) {
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .a)();
    switch((0,_lib_article__WEBPACK_IMPORTED_MODULE_3__/* .lockTypeOf */ .K3)(user, props.article)){
        case "none":
            return null;
        case "locked":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_0__/* .IcomoonIcon */ .g, {
                name: "lock-fill",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(common, "            color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";", props.size === "small" && small)
            });
        case "unlocked":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_0__/* .IcomoonIcon */ .g, {
                name: "unlock-fill",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(common, "            color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray60 */ .O9.gray60, ";", props.size === "small" && small)
            });
    }
};


/***/ }),

/***/ 42401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ TrialModal; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _atoms_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99338);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20932);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48261);








var TrialModal = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_atoms_Modal__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        isHidden: !props.isOpen,
        onClose: props.hideModal,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("max-width:640px;.modal-content{padding:0;}"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("img", {
                alt: "trial modal image",
                src: "/static/images/companies/guest/trial.png",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("border-radius:5px 5px 0 0;width:100%;")
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("display:flex;align-items:center;flex-direction:column;", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.untilMedium, "{padding:16px 16px 36px;}", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.large, "{padding:16px 40px 32px;}"),
                "data-testid": "trial-modal",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_3__/* .font.weight.normal */ .LZ.weight.normal, ";line-height:175%;letter-spacing:0.02em;color:", plume_ui__WEBPACK_IMPORTED_MODULE_3__/* .colors.text */ .O9.text, ";", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.untilMedium, "{font-size:14px;}", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.large, "{font-size:16px;}"),
                        children: "有料契約限定のコンテンツです。無料トライアルに申し込むと、すべての機能/コンテンツをご覧になれます（一部対象外の機能あり）。"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: _lib_url__WEBPACK_IMPORTED_MODULE_5__/* .trialRequestUrl */ .d1,
                        passHref: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                            target: "_blank",
                            className: "trial-link",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.untilMedium, "{margin-top:16px;width:310px;}", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.large, "{margin-top:26px;width:320px;}"),
                                children: "無料トライアルに申し込む"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_2__.A, {
                        decoration: "none",
                        href: _lib_url__WEBPACK_IMPORTED_MODULE_5__/* .loginPath */ .Qv,
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("margin-top:20px;font-size:14px;"),
                        children: "契約済みの方はログインしてください"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 67014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ desktopMaxWidth; },
/* harmony export */   "n": function() { return /* binding */ desktopMinWidth; }
/* harmony export */ });
var desktopMaxWidth = "769px";
var desktopMinWidth = "770px";


/***/ }),

/***/ 17239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useModal = function(props) {
    var ref;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState((ref = props === null || props === void 0 ? void 0 : props.open) !== null && ref !== void 0 ? ref : false), 2), isOpen = ref1[0], setIsOpen = ref1[1];
    var show = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        return setIsOpen(true);
    }, [
        props.key
    ]);
    var hide = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        return setIsOpen(false);
    }, [
        props.key
    ]);
    return {
        isOpen: isOpen,
        show: show,
        hide: hide
    };
};


/***/ }),

/***/ 11566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gs": function() { return /* binding */ isText; },
/* harmony export */   "LV": function() { return /* binding */ stripMarkdown; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "jY": function() { return /* binding */ isImageLink; },
/* harmony export */   "sQ": function() { return /* binding */ isAnchorImage; }
/* harmony export */ });
var stripMarkdown = function(text) {
    var linkRegex = /\[(.*?)\][\[\(].*?[\]\)]/g;
    return text.replace(linkRegex, "$1");
};
var isText = function(node) {
    return Array.isArray(node) && typeof node[0] === "string";
};
var isImageLink = function(node) {
    return Array.isArray(node) && node.some(isImage);
};
var isImage = function(node) {
    return typeof node === "object" && node.hasOwnProperty("props") && node.props.hasOwnProperty("src");
};
var isAnchorImage = function(node) {
    return typeof node === "object" && node.hasOwnProperty("props") && node.props.hasOwnProperty("href") && node.props.children.some(isImage);
};


/***/ }),

/***/ 42708:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  let id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  let callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ })

}]);